export default {
  titleBanner: {
    subtitle: 'BLE | Bluetooth Low-Energy',
    title: 'BLE 위치 추적 및 포지셔닝 기술',
    description: '*BLE은 무선 통신 기술 중 하나로, 전력 소모량이 적고 대신 데이터 전송 속도가 낮습니다. <br/> 주로 소형 기기나 저전력 센서에서 사용되며, 비컨과 같은 작은 발신기로도 활용됩니다. <br/> 스마트 홈, 스마트 시티, 스마트 팩토리 및 IoT 기술 등에서도 사용됩니다.'
  },
  definition: {
    title: 'BLE란 무엇인가요?',
    text: 'Bluetooth Low Energy(이하 BLE)는 무선 통신을 위한 라디오 주파수(RF) 기술로, 다양한 실내 위치 추적 용도에 활용할 수 있습니다. BLE 기술을 이용하면 사람, 기기, 자산 등의 위치를 감지하고 추적하여 자산 추적, 실내 네비게이션, 근접 서비스 등 다양한 용도로 활용할 수 있습니다. Wi-Fi 및 UWB와 같은 다른 통신 프로토콜과 마찬가지로 BLE도 무선으로 데이터를 송수신하는 데 사용될 수 있습니다. <br/><br/> BLE 4.0은 2010년에 출시되어 이전 버전인 블루투스 클래식보다 훨씬 적은 전력을 소비하도록 설계되었습니다. 이러한 에너지 효율적인 디자인으로 인해 스마트폰 및 다양한 무선 기기와의 통합, 웨어러블 기기 및 IoT 기기 개발, 배터리 작동형 BLE 비콘 등 다양한 새로운 블루투스 기술이 등장하게 되었습니다.'
  },
  tech: {
    title: 'BLE 기술의 진화', 
    text: 'BLE 기술의 성장은 글로벌 블루투스 생태계에 근본적인 변화를 가져왔습니다. 많은 블루투스 기기들이 실내 공간에 진입했으며, 이제 전 세계에 80억 개 이상의 블루투스 기기가 있습니다. 새로운 블루투스 호환 인프라 및 도구들은 혁신적인 위치인식 기능을 제공합니다. <br/><br/> 2013년, 애플의 iBeacon이 최초로 출시된 이후 많은 BLE 기술들이 등장했습니다. iBeacon은 물리적인 비콘들이 근접한 무선 기기들과 통신할 수 있도록 하여 iOS 및 Android 애플리케이션과 함께 작동할 수 있게 만들어졌습니다. 2015년 구글은 개방성과 상호 운용성을 고려한 비콘 프로토콜인 Eddystone을 출시했습니다. 이 두 가지 선도적인 비콘 프로토콜과 함께 사용되는 많은 물리적 비콘 제품들과 위치 추적 센서 및 태그와 같은 다른 BLE 기술들은 다양한 실내 위치 추적 및 위치 서비스 애플리케이션을 가능하게 하여 사람들과 기기가 실내 공간과 상호작용하는 방식을 변화시켰습니다. <br/><br/> 이러한 기술들과 전반적인 블루투스 통신 프로토콜은 계속해서 발전하고 있습니다. 2016년 새로운 블루투스 버전인 Bluetooth 5.0이 소개되었습니다. BLE 4.0을 기반으로 한 이 새로운 버전은 더 높은 데이터 전송 속도와 더 긴 거리에서의 통신이 가능합니다. 2019년 공개된 Bluetooth 5.1은 방향 탐지(direction finding, DF)를 통해 보다 정확한 위치 감지를 가능하게 하여 센티미터 수준의 정확도를 제공할 것으로 예상됩니다. <br/><br/> BLE는 실내 위치 추적을 위한 가장 인기 있는 RF 기술 중 하나로, 무선 기기에서 많이 사용되며, 저전력, 저비용, 쉽게 구현할 수 있는 하드웨어 옵션이 많고, 다양한 위치 기반 애플리케이션에서 유연하게 사용할 수 있는 특징을 가지고 있습니다.'
  },
  beacon: {
    title: 'BLE Beacon 이란?',
    text: 'BLE 비콘은 작고 다용도이며 저전력 블루투스 송신기로, BLE가 가능한 스마트폰과 같은 무선 기기에서 감지될 수 있습니다. 비콘은 벽이나 구조물에 부착되거나 이동 가능한 자산에 놓여져서 실내 위치 측위 애플리케이션에 위치 참조를 제공합니다. 이는 BYOD(Bring Your Own Device) 개념을 지원하여 누구나 스마트폰이나 다른 내장 장치를 사용하여 BLE가 가능한 애플리케이션과 상호작용할 수 있도록 합니다. BLE 비콘은 장치의 위치를 찾아서 문서, 비디오, 앱 등과 같은 관련 콘텐츠를 제공하거나, 사용자의 시간 또는 위치에 대한 안내를 제공하여 사용자를 안내하고 참여시킵니다. <br/><br/> 비콘은 정기적인 간격으로 신호를 송출하여 다른 BLE가 가능한 기기에서 감지할 수 있습니다. 비콘에서 수집한 위치 데이터는 BLE 기기에서 수집되어 IPS(Internet Positioning System)로 전송되어 기기의 위치를 결정합니다. 이는 다양한 위치 인식 애플리케이션을 지원하며, 특정 동작을 트리거할 수도 있습니다. <br/><br/> 비콘은 모양과 크기가 다양합니다. 많은 비콘은 내장형 배터리를 사용하여 여러 해동안 작동하거나 USB와 같은 연결로 전원을 공급받을 수 있습니다. BLE 기술은 일반적으로 다른 RF 기술보다 생산 비용이 적게 들기 때문에 고유한 요구사항에 맞는 배치를 위해 맞춤형 가능성이 있는 작고 저렴하며 유지보수가 적게 필요한 하드웨어 옵션을 제공합니다. 일부 비콘은 BLE를 넘어서 가속도계나 온도 센서와 같은 추가 기술을 통합하여 향상된 결과를 얻을 수 있습니다. <br/><br/> 가상 비콘은 많은 추가 하드웨어 없이 BLE 비콘 기술을 추가할 수 있도록 합니다. 가상 블루투스 비콘을 사용하면 호환 가능한 Wi-Fi 액세스 포인트에 안테나를 추가하고 다양한 실내 위치 측위 애플리케이션에 대한 추가 소프트웨어 도구와 함께 사용할 수 있습니다. <br/><br/> 많은 일반 기업용 Wi-Fi 액세스 포인트는 이제 내장형 BLE 기술이 탑재되어 있습니다. 이를 통해 조직은 액세스 포인트를 비콘 및 센서로 사용하여, 보조 인프라를 설정하지 않고도 전송 중인 BLE 기기를 감지하고 위치를 파악할 수 있습니다.'
  },
  howItWorks: {
    title: 'BLE 포지셔닝은 어떻게 동작하나요?',
    text: 'BLE 실내 위치 측위 솔루션은 BLE 지원 센서 또는 비콘을 사용하여 실내 공간에서 스마트폰이나 추적 태그와 같은 블루투스 기기를 감지하고 위치를 파악합니다. 센서에서 수집한 위치 데이터 또는 비콘이 모바일 기기로 전송한 데이터는 다양한 위치 측위 응용 프로그램에 의해 수집되어 분석되며, 이를 기반으로 다양한 위치 인지 사용 사례가 구현됩니다.',
    items: [
      {
        title: '비콘을 사용한 BLE 포지셔닝',
        description: 'BLE 비콘은 지속적으로 BLE 신호를 발신합니다. 이러한 신호는 스마트폰 및 BLE 지원 센서를 비롯한 주변 기기에 의해 감지될 수 있습니다. 비콘이 실내 공간 전체에 고정된 위치에 배치되면, 지속적으로 발신되는 신호에는 해당 비콘의 고유 식별자가 포함됩니다. 이 식별 코드는 주기적으로 다른 데이터와 함께 비콘 통신 프로토콜에 따라 전송됩니다. <br/><br/> 전용 앱이나 사전 구성된 서비스를 지원하는 스마트폰 또는 다른 무선 기기는 비콘의 범위 내에 있을 때, 사용자 중심 방식으로 비콘에서의 신호를 수신 및 분석하거나 서버 중심 방식으로 이 정보를 서버에 전송할 수 있습니다. 하나의 비콘과 기기 간의 감지는 근접 기반의 위치 서비스를 활성화하여 비콘과 기기가 서로 범위 내에 있는지 여부를 결정할 수 있습니다. 실내 공간 전체에 전략적으로 배치된 여러 비콘 간의 통신을 통해 비콘과 무선 기기 간의 관계를 이용한 벡터맵을 추출하여 기기의 위치를 결정할 수 있습니다. 애플리케이션에 따라, 기기의 결정된 위치는 특정 작업을 트리거하거나 다양한 응용 프로그램 또는 서비스에 활용될 수 있습니다. <br/><br/> BLE 비콘은 모바일 기기에도 배치할 수 있으며, 이는 자산 추적 시나리오에서 유용할 수 있습니다. 이러한 모바일 기기 위에 설치된 BLE 비콘은 고정된 BLE 지원 센서에서 감지 및 위치를 파악할 수 있습니다.'
      },
      {
        title: '센서를 사용한 BLE 포지셔닝',
        description: 'BLE 센서를 사용한 위치 측위는 실내 공간에 고정 위치에 배치된 BLE 지원 센서를 활용합니다. 이러한 센서는 BLE 스마트폰, 자산 추적 태그, 비콘, 인원 배지, 웨어러블 기기 등 블루투스 기기에서 발신되는 신호 세기를 기반으로 수동으로 감지하고 위치를 파악합니다. 이 위치 데이터는 중앙 실내 위치 측위 시스템(IPS) 또는 실시간 위치 추적 시스템(RTLS)으로 전송됩니다. 위치 엔진은 이 데이터를 분석하여 벡터맵을 추출하고 이를 이용하여 발신 장치의 위치를 결정합니다. 이 좌표는 공간의 실내 지도상 장치 또는 자산의 위치를 시각화하거나, 특정 위치 인지 응용 프로그램에 따라 다른 용도로 활용될 수 있습니다.'
      }
    ]
  },
  accuracy: {
    title: '블루투스 포지셔닝은 얼마나 정확합니까?',
    text: 'BLE 실내 위치 추적 및 실시간 위치 시스템은 시스템 아키텍처, 하드웨어 선택 및 배치된 센서 또는 비콘의 밀도에 따라 다양한 수준의 정확도를 제공할 수 있습니다. BLE 센서 또는 비콘을 사용한 실내 위치 추적 모두 최적 조건과 배치를 고려하면 일반적으로 5m 이하의 위치 정확도를 제공할 수 있습니다.',
    text2: 'Wi-Fi 기술과 유사하게, Bluetooth도 일반적으로 장치의 신호 강도(RSSI)를 이용하여 위치를 추정합니다. 이 위치 결정 방법은 일반적으로 미터 수준의 위치 정확도를 제공하며 UWB와 같은 기술에 비하면 훨씬 적합도가 낮습니다. UWB는 거리 기반 측정 기술인 ToF(Time of Flight)을 사용하여 매우 정확한 센티미터 수준의 정확도를 제공합니다. BLE는 현재 실내 위치 추적용으로 가장 정확한 RF 기술은 아니지만 여전히 매우 효과적이며 가장 널리 사용되는 기술 중 하나입니다. 많은 실내 위치 추적 시나리오에서는 높은 정확도가 필요하지 않으므로, BLE는 유연성, 저전력 및 저비용, 구현의 용이성 등 많은 독특한 장점을 제공하는 적합한 선택입니다. <br/><br/> Bluetooth 5.1의 출시와 새로운 방향 결정 기능으로 인해 BLE는 sub-meter 수준의 정확도로 위치를 결정할 수 있게 될 것입니다. 이것은 Angle of Arrival (AoA)를 통해 Bluetooth 신호의 방향을 계산할 수 있는 새로운 능력 덕분에 이루어집니다. 이 기술은 신호 강도 (RSSI)와 함께 사용되어 장치와 자산의 위치를 추적하고 향상된 정확도를 제공합니다. 방향을 찾기 위해서는 단일 안테나를 가진 모바일 자산(태그 또는 비콘)이 다중 안테나 배열을 가진 고정 BLE 센서에게 전송됩니다. 신호 수신 후 다중 안테나의 위상 변화를 측정하여 송신 모바일 장치의 접근 각도를 결정합니다. RSSI와 AoA를 결합하여 센티미터 수준의 정확도로 장치 좌표를 생성합니다.'
  },
  range: {
    title: 'BLE의 통신 범위는 얼마입니까?',
    text: 'BLE 위치 추적 기술의 범위는 BLE 비콘 또는 BLE 활성화 센서를 사용하는지, 실내 공간의 특성 등에 따라 다를 수 있습니다. BLE는 일반적으로 UWB 또는 Wi-Fi와 같은 다른 RF 기술보다 짧은 범위 내에서 작동하며, 최적의 조건과 배치에서는 0~25미터 내에서 가장 잘 작동하며, 최대 100미터까지 작동할 수 있습니다.'
  },
  difference: {
    title: 'BLE는 다른 RF 기술과 어떻게 다릅니까?',
    text: '블루투스는 다른 무선 표준 기술과 마찬가지로, 개별적인 요구 사항, 예산, 시설 및 특정 위치 기반 사용 사례에 따라 적합한 옵션일 수 있는 고유한 특성과 장점을 제공합니다. BLE와 다른 기술 간 가장 중요한 차이점은 적은 전력 소비와 많은 위치 인식 응용 프로그램에서의 유연성입니다. BLE는 실내 공간 전반에서 장치에 내장되어 있으며, 많은 위치 추적 시스템에서 활용되며, 산업과 다양한 사용 사례를 포함한 실내 위치 추적을 위해 확장될 수 있습니다.',
    items: [
      {
        title: 'BLE vs Wi-Fi',
        description: 'BLE와 Wi-Fi는 우리 일상 생활과 실내 공간 전반에 걸쳐 가장 보편적인 RF 기술 중 두 가지입니다. 둘 다 2.4GHz 주파수 범위에서 작동하며, 대규모 생태계와 실내 위치 추적에 대한 확립된 사용을 포함한 많은 유사한 특징이 있습니다. BLE와 Wi-Fi 모두 RSSI를 사용하여 사람, 장치 및 자산의 위치를 감지합니다. 그러나 BLE는 더 높은 정확도를 달성하는 것으로 알려져 있습니다. BLE는 훨씬 적은 전력을 요구하여 더 유연한 하드웨어 옵션과 응용 프로그램을 가능하게 합니다. 그러나 많은 기관들은 이미 Wi-Fi 인프라를 보유하고 있어, BLE의 도입은 새로운 비콘, 센서 등의 통합을 필요로 합니다. Wi-Fi는 더 긴 범위와 높은 데이터 전송률을 지원할 수 있으며, BLE는 Wi-Fi 보다 제한적인 영역입니다.'
      },
      {
        title: 'BLE vs UWB',
        description: 'BLE와 UWB는 저전력, 저비용, 자산 추적 기술 등의 공통적인 특성을 가지고 있습니다. 그러나 UWB는 블루투스보다 훨씬 뛰어난 정확도를 제공할 수 있습니다. 이것은 UWB의 ToF를 통한 정확한 거리 기반 위치 결정 방법 때문입니다. BLE는 일반적으로 RSSI를 통해 장치의 위치를 파악하지만, 이는 장치가 비콘이나 센서에 비해 강한 또는 약한 신호를 전송하는지에 따라 상당히 낮은 정확도를 제공합니다. BLE는 UWB에 비해 훨씬 짧은 범위와 데이터 전송률을 가지고 있습니다. 그러나 블루투스는 유연한 하드웨어 옵션인 BLE 비콘, 자산 태그 및 센서 등을 통해 많은 실내 공간에 도입될 수 있는 널리 사용되는 RF 기술입니다.'
      }
    ]
  },
  advantage: {
    title: 'BLE의 주요 장점',
    items: {
      low: {
        title: '저전력, 저비용',
        description: 'BLE는 저전력 소비와 저렴한 비용으로 만들어진 기술로, BLE 센서, 비콘, 자산 또는 인적 태그에서 많이 사용되는 이상적인 RF 기술입니다.'
      },
      distribute: {
        title: '배포가 용이함',
        description: 'BLE는 배포가 쉬운 솔루션과 네트워크에 종속되지 않거나 독립적인 유연한 하드웨어 옵션을 제공하여 Bluetooth 생태계에 간단하게 통합될 수 있습니다.'
      },
      tech: {
        title: '확장 가능한 기술',
        description: '이 기술을 활용하여 자산 추적, Bluetooth 장치 감지, 실내 위치 파악과 길 안내, 근접 서비스 등 다양한 위치 인식 사용 사례를 구현할 수 있습니다.'
      }
    }
  },
  useCase: {
    title: 'Bluetooth 포지셔닝 사용 사례',
    description: 'BLE의 확장성은 다양한 실내 위치 파악 사용 사례에 효과적인 옵션으로 작용합니다. <br/> 다음은 BLE 실내 위치 파악 기술이 사용되는 일부 사용 사례 및 응용 분야입니다.',
    card: {
      asset: {
        title: '자산 추적',
        description: 'BLE는 물리적 자산 추적을 위한 핵심 RF 기술 중 하나로 작용합니다. 많은 산업 분야의 기업은 Bluetooth의 저전력, 유연성, 구현 용이성과 같은 기술을 활용하여 주요 자산 및 장비의 위치와 상태를 실시간으로 추적할 수 있습니다.',
        items: [
          {
            name: '의료 서비스',
            description: '주요 장비(예: 환기장치 및 휠체어 등)의 위치를 빠르게 찾고 추적하기 위해 자산 추적 기능을 추가하세요.'
          },
          {
            name: '스마트 제조',
            description: '장비, 기계 및 자원의 위치와 움직임을 파악하여 시각화하세요.'
          },
          {
            name: '창고 관리',
            description: '대규모 시설 내에서 장비, 도구 및 재고물의 위치를 찾기 위해 자산 추적 기능을 통합하세요.'
          }
        ]
      },
      employee: {
        title: '직원 및 사람 추적',
        description: '기업은 유연한 BLE 비콘, 직원 태그, 그리고 센서를 활용하여 직원과 인력의 위치를 파악하여 다양한 위치 기반 애플리케이션을 구현할 수 있습니다.',
        items: [
          {
            name: '무선 장치 탐지',
            description: '정부와 기업 건물 등 보안에 민감한 시설들에서는 센서를 사용하여 실내 공간 내 BLE 및 기타 RF 전송 장치를 감지할 수 있습니다.'
          },
          {
            name: '작업 공간 최적화',
            description: '낮은 비용의 태그, 예를 들어 직원 배지, 추적 스티커 등을 활용하여 공간 활용 및 직원 위치를 파악하여 운영 효율성과 생산성을 증대시킬 수 있습니다.'
          },
          {
            name: '직원 안전',
            description: '실내 공간을 보다 안전하게 만들고 비상사태나 대피 상황 시 직원을 신속히 위치 파악하거나 알릴 수 있도록 합니다.'
          }
        ]
      },
      location: {
        title: '위치 서비스',
        description: 'BLE(Bluetooth Low Energy) 기술을 이용한 실내 위치 추적 시스템을 도입함으로써 기관이나 회사는 스마트 빌딩을 구축할 수 있습니다. 이를 통해 건물 내부에서 사람들의 위치 정보를 파악하여 다양한 상호작용이나 메시지 전송 등 다양한 기능을 제공할 수 있습니다.',
        items: [
          {
            name: '근접 메시지',
            description: 'BLE 실내 위치 추적 기술을 도입하여 고객 및 자산 근처의 목적지를 식별하고 이 데이터를 활용하여 쿠폰, 마케팅 캠페인, 인근 관광지 등 하이퍼로컬 컨텐츠를 포함한 직접적인 고객 상호작용을 유도하는 참여형 고객 경험을 제공할 수 있습니다.'
          },
          {
            name: '지오펜싱',
            description: '실내 공간의 다양한 영역 주변에 가상 지리적 경계를 생성하여 사용자가 지정된 영역에 진입, 이탈 또는 머무를 때 특정 작업을 실행할 수 있도록 합니다.'
          }
        ]
      },
      navigation: {
        title: '실내 내비게이션',
        description: '블루투스 위치 기술을 활용한 실내 내비게이션 및 길 안내 기능으로 공간을 즉시 익숙하게 만들고 탐험할 수 있습니다',
        items: [
          {
            name: '실내 내비게이션',
            description: 'BLE 실내 위치 기반 서비스를 활용하여 기업, 의료, 소매, 호텔, 교통 등 다양한 산업의 시설에 대한 탁월한 실내 체험을 제공하세요.'
          },
          {
            name: 'Blue-dot Wayfinding',
            description: 'BLE 비콘과 다른 실내 위치 기술을 사용하여, 기업, 의료, 소매, 호텔, 교통 등 여러 산업 분야의 시설에서 블루 닷(Blue Dot) 체험을 통해 차례대로 안내 및 길찾기를 가능하게 할 수 있습니다.'
          }
        ]
      },
      business: {
        title: '비즈니스 인텔리전스',
        description: 'BLE는 가치 있는 위치 데이터를 수집하여 강력한 조직적 통찰력으로 변환하는 데 활용될 수 있습니다.',
        items: [
          {
            name: '분석 및 비즈니스 인텔리전스',
            description: '자산, 인력 및 장치의 위치를 찾아 추적하고 시간이 지남에 따라 이 위치 데이터를 분석할 수 있습니다. 내부 공간에서 방문자가 상호 작용하는 방식을 파악하여 더 지능적이고 정보화된 비즈니스 결정을 내릴 수 있도록 시야를 넓힐 수 있습니다. 이러한 작업을 위해 BLE를 활용할 수 있습니다.'
          }
        ]
      }
    }
  },
}